import { SavedMedium, SaveMedium } from '@zoopla-eng/zds/icons';
import { fontGroups } from '@zoopla-eng/zds/themes';
import React from 'react';
import {
    iconWrapperStyle,
    labelStyle,
    saveWrapperStyle
} from './save-listing.styles.css';

export type ClickHandler = (event: React.MouseEvent<HTMLElement>) => void;

type SaveListingProps = {
    onSaveClick?: ClickHandler;
    isSaved: boolean;
};

const ariaLabelUnfavourite = 'Remove this listing from your favourites';
const ariaLabelFavourite = 'Save this listing to your favourites';
const labelSaved = 'Saved';
const labelSave = 'Save';

const SaveListing: React.FC<SaveListingProps> = ({ isSaved, onSaveClick }) => {
    return (
        <button
            className={`${saveWrapperStyle} ${fontGroups.ladle}`}
            aria-label={isSaved ? ariaLabelUnfavourite : ariaLabelFavourite}
            onClick={onSaveClick}
        >
            <div className={iconWrapperStyle}>
                {isSaved ? <SavedMedium /> : <SaveMedium />}
            </div>
            <div className={`${labelStyle} ${fontGroups.ladle}`}>
                {isSaved ? labelSaved : labelSave}
            </div>
        </button>
    );
};

export { SaveListing };
